import React, {Suspense, lazy} from 'react';
import { BrowserRouter, Routes, Route, Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { connect } from "react-redux";
const history = createBrowserHistory();
import { Layout } from 'antd';
import ServerApi from '../utils/ServerApi';
import appConst from '../constents/app.const';
import api_url from '../utils/requestApi';
import { setToken, setUserData, checkPermission } from "../actions/user.action";
import {deleteAllCookies} from '../utils/commonFunction';
import menuHeader from '../utils/menuHeader';
import menuSider from '../utils/menuSider';
import HeaderSection from './general/HeaderSection';
import SiderSection from './general/SiderSection';
import MainContentSection from './general/MainContentSection';
import FooterSection from './general/FooterSection';
import Account from './pages/Account';
import AccountUpdate from './pages/Account/AccountUpdate';
import PasswordUpdate from './pages/Account/PasswordUpdate';
import ClubUpdate from './pages/Account/ClubUpdate';
import DepositHistory from './pages/DepositHistory';
import DepositAction from './pages/DepositHistory/DepositAction';
import WithdrawHistory from './pages/WithdrawHistory';
import TransectionHistroy from './pages/TransectionHistroy';
import PerTotal from './pages/TransectionHistroy/PerTotal';
import WithdrawAction from './pages/WithdrawHistory/WithdrawAction';
import WorkHistroy from './pages/WorkHistroy';
import Login from './pages/LogIn';
import Signup from './pages/Signup';

import SinglePot from './pages/MainContentCenter/SinglePot';
import Upcoming from './pages/MainContentCenter/Upcoming';
import Setting from './pages/Setting';
import SendCoin from './pages/SendCoin';
import SendCoinHistory from './pages/SendCoin/SendCoinHistory';
import SixDigitPin from './pages/Account/SixDigitPin';
import Sider from 'antd/es/layout/Sider';
class App extends React.Component {
    constructor(props){
        super(props)
        this.onMyAccount = this.onMyAccount.bind(this)
        this.onLogout = this.onLogout.bind(this)
    }
    state = {
        logedIn: false,
        authFail: false,
        authFailMsg: 'Input your credential',
        loader: {
            loading: false,
            title: ''
        }
    }
    componentDidMount(){
        const _this = this
        if(_this.props.token){
            this.onMyAccount()
        }
        window.__onLogout__ = () => {
            _this.onLogout();
        }
        //window.enableLoading = this.enableLoading;
    }
    onMyAccount = () => {
        const _this = this;
        let serverApi = new ServerApi(appConst.apiUrl, this.props.token)
        serverApi.getUserData(api_url.account_on, (userInformation) => {
            _this.props.updateUserData(userInformation?.data)
            _this.setState({
                logedIn: true,
                authFail: false
            })
        })
    }
    // enableLoading = (title = "", loading = false) => {
    //     this.setState({
    //       loadingObj: {
    //         title: title,
    //         isShow: loading,
    //       },
    //     })
    // }
    onLogin = (username, password) => {
        let serverApi = new ServerApi(appConst.authServerUrl, null),
        _this = this
        //enableLoading("Please Wait", true)
        // _this.setState({ logedIn: true, authFailed: false });//##for testing only --##leave this commented
        serverApi.login(api_url.account_in, username, password, (returnData) => {
            if (returnData.success == 1 && returnData.token) {
                _this.setState({ logedIn: true, authFail: false }, () => {
                    _this.props.updateToken(returnData.token)
                    serverApi = new ServerApi(appConst.apiUrl, returnData.token)
                    serverApi.getUserData(api_url.account_on, (userInformation) => {
                        _this.props.updateUserData(userInformation.data)
                    });
                    //enableLoading("", false)
                })
            } else {
                _this.setState({ logedIn: false, authFail: true, authFailMsg: returnData.message })
                //enableLoading("", false)
            }
        })
    }
    onLogout = () => {
        const serverApi = new ServerApi(appConst.authServerUrl, this.props.token),
        _this = this;
        deleteAllCookies(); // remove from cookie
        _this.setState({ logedIn: false }, () => {
            if (_this.state.logedIn) {
                serverApi.logout()
            }
            window.location.reload(false)
        })
    }
     onSignup = (body) => {
        return new Promise((resolve, reject) => {
          const serverApi = new ServerApi(appConst.apiUrl, null);
      
          serverApi.account_create(api_url.account_create, body, (returnData) => {
            if (returnData.success === 1) {
              this.setState({
                authFail: false,
                authFailMsg: returnData.message
              });
              resolve(returnData); 
            } else {
              this.setState({
                authFail: true,
                authFailMsg: returnData.message
              });
              reject(new Error(returnData.message || "Registration failed"));
            }
          });
        });
      };
      
    render(){
        return(
            <div>
                <BrowserRouter history={history}>
                    <div>
                 
            
                            <Layout>
                                <HeaderSection
                                    menuHeader={menuHeader}
                                    menuSider={menuSider}
                                    logedIn={this.state.logedIn}
                                    userInfo={this.props.userData?this.props.userData.info:'Name'}
                                    onLogin={this.onLogin}
                                    authFail={this.state.authFail}
                                    authFailMsg={this.state.authFailMsg}
                                    logout={this.onLogout} 
                                />
                                    <>
                                        <Routes>
                                            <Route path="/pot page" element={<MainContentSection {...this.props} isSingle={false} onMyAccount={this.onMyAccount}/>}/>
                                            <Route path="/homedfyjhtryh" element={<MainContentSection {...this.props} isSingle={false} onMyAccount={this.onMyAccount}/> } />
                                            <Route path="/upcoming" element={<Upcoming />}/>
                                            <Route path="/*" element={<MainContentSection {...this.props} isSingle={false}  onMyAccount={this.onMyAccount}/>} />
                                            <Route path="/pot single page" element={<MainContentSection {...this.props} isSingle={true} onMyAccount={this.onMyAccount}/>} />
                                            {/* <Route path="/pot one by c on" element={<SinglePot work={"work_c"}/>}/>
                                            <Route path="/pot one by f do" element={<SinglePot work={"work_f"}/>}/>
                                            <Route path="/pot one by t no" element={<SinglePot work={"work_t"}/>}/>
                                            <Route path="/pot one by v yes" element={<SinglePot work={"work_v"}/>}/> */}
                                            {(this.state.logedIn === false)?(
                                                <>
                                                    <Route path="/login" element={<Login onLogin={this.onLogin} authFail={this.state.authFail} authFailMsg={this.state.authFailMsg} />}/>
                                                    <Route path="/join" element={<Signup onSignup={this.onSignup} authFail={this.state.authFail} authFailMsg={this.state.authFailMsg}/>}/>
                                                </>
                                            ):(
                                                <>
                                                    <Route path="/account info" element={<Account userInfo={this.props.userData?this.props.userData.info:'Name'}/>}/>
                                                    <Route path="/account update" element={<AccountUpdate {...this.props} onMyAccount={this.onMyAccount} userInfo={this.props.userData?this.props.userData.info:'Name'}/>}/>
                                                    <Route path="/password update" element={<PasswordUpdate {...this.props} userInfo={this.props.userData?this.props.userData.info:'Name'}/>}/>
                                                    <Route path="/club update" element={<ClubUpdate {...this.props} userInfo={this.props.userData?this.props.userData.info:'Name'}/>}/>
                                                    <Route path="/deposit history" element={<DepositHistory {...this.props}/>}/>
                                                    <Route path="/withdraw history" element={<WithdrawHistory {...this.props}/>}/>
                                                    <Route path="/transection history" element={<TransectionHistroy {...this.props}/>}/>
                                                    <Route path="/per total transection history" element={<PerTotal {...this.props}/>}/>
                                                    <Route path="/work history" element={<WorkHistroy {...this.props}/>}/>
                                                    <Route path="/deposit" element={<DepositAction {...this.props}/>}/>
                                                    <Route path="/withdraw" element={<WithdrawAction {...this.props} onMyAccount={this.onMyAccount}/>}/>
                                                    <Route path="/settings option" element={<Setting {...this.props} />} />
                                                    <Route path="/send coin" element={<SendCoin {...this.props} onMyAccount={this.onMyAccount}/>} />
                                                    <Route path="/send coin history" element={<SendCoinHistory {...this.props}/>}/>
                                                    <Route path="/six digit pin" element={<SixDigitPin {...this.props}/>}/>
                                                </>
                                            )}
                                            
                                        </Routes>
                                    </>
                                <FooterSection />
                                {/*  <FooterProfile userInfo={this.props.userData?this.props.userData.info:'Name'} logedIn={this.state.logedIn}/> /> */}
                               
                            </Layout>
                    
                    </div>
                </BrowserRouter>
            </div>
        )
    }
}
const mapStateToProps = (state /*, ownProps*/) => {
    return {
      token: state.userStore.token,
      userData:state.datasStore?.userData,
      permissions:state.datasStore?.userData?.permissions,
    };
  };
  const mapDispatchToProps = (dispatch) => {
    return {
      updateToken: (token) => {
        dispatch(setToken(token));
      },
      updateUserData: (data) => {
        dispatch(setUserData(data));
      },
    };
  };
export default connect(mapStateToProps, mapDispatchToProps)(App);